import React, { useState } from 'react';
import CustomAvailableItems from '../../../../../components/CustomAvailableAssignedItems/CustomAvailableItems';
import {
    CleanIcon,
    EmailSubsectionChip,
    IconDocumentLinedGrid,
    PersonChip,
    PhoneSubsectionChip,
    PlusIconsOptions,
} from '../../../../../components/buttons/IconButtons';
import { SimpleSearch } from '../../../../../reduxToolkit/Search/SearchApi';
import { SEARCH_MODEL } from '../../../../../components/table/Model/TableModel';
import { TABLES } from '../../../../../Apis/Tables';
import CustomTooltip from '../../../../../components/CustomTooltip';
import { getFullName } from '../../../../../Apis/functions';
import CustomCard from '../../../../../components/CustomCard';
import ButtonIcon from '../../../../../components/buttons/ButtonIcon';

/**
 * @Author: Susana Garcia Rodriguez
 * @JobTitle: Frontend - IBL
 * @Email: sgarcia@ibl.mx
 */

const AssignedEmployees = ({ id, selected, setSelected, handleClearEmployees }) => {
    const [results, setResults] = useState({
        content: [],
        totalElements: 0,
    });

    const [searchElement, setSearchElement] = useState('');
    const [search, setSearch] = useState(false);
    const [simpleSearch, setSimpleSearch] = useState(false);
    const [modified, setModified] = useState(false);

    return (
        <div>
            <div className='col-12 d-flex justify-content-end mb-2'>
                {!id && (
                    <ButtonIcon
                        id='btn_aes_clean_fields'
                        Icon={CleanIcon}
                        onClick={handleClearEmployees}
                        title={'clear_instances'}
                        className={'btn-clean-secondary-600'}
                        tooltipPlacement={'right'}
                        iconProps='btn-icon-svg-12px icon-color-general-00'
                    />
                )}
            </div>

            <CustomAvailableItems
                results={results}
                setResults={setResults}
                searchElement={searchElement}
                setSearchElement={setSearchElement}
                setSearch={setSearch}
                setSimpleSearch={setSimpleSearch}
                modified={modified}
                setModified={setModified}
                selected={selected}
                setSelected={setSelected}
                keyId={'userId'}
                tableTitle={true}
                tableIconTitle={<IconDocumentLinedGrid />}
                selectedSectionIconTitle={<PlusIconsOptions />}
                labelRowsPerPage={'employees_per_page'}
                tableNotInformationLegend={'you_havent_created_any_employees_yet'}
                selectedSectionNotInformationLegend={'no_employees_added_yet'}
                tableEndPoint={(body) => SimpleSearch({ body })}
                tableBuildBody={({ page, rowsPerPage, searchElement }) =>
                    SEARCH_MODEL.setObject({
                        page: page,
                        size: rowsPerPage,
                        key: searchElement,
                        model: TABLES.EMPLOYEES,
                    })
                }
                viewTypeName={'employees'}
            />
        </div>
    );
};

export default AssignedEmployees;
